import { HomePageInfoModel } from "@/models/HomePageInfoModel";

export default class HomePageState {
  homePageInfoModel?: HomePageInfoModel;
  loaded = false;
}
